export default __webpack_public_path__ + "static/media/banner_course_1.90d5d0ef.png";